var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.64093eb3a613b71ef7cb22241efc6826.svg#n';
                    var viewUrl = 'sprites.64093eb3a613b71ef7cb22241efc6826.svg#view-n';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 54 28',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };